import { ActivityWithAggregate } from '@/api/models/aggregate'

export function calculateDuration(activity: ActivityWithAggregate, duration: number = 0): number {
  if (activity.duration) {
    return duration + activity.duration
  }

  if (!activity.children?.length) {
    return duration
  }

  return activity.children.reduce((acc, child) => calculateDuration(child.childActivity, acc), duration)
}
